import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
export function Footer() {
  const [activeModal, setActiveModal] = useState<string | null>(null);
  const openModal = (modalType: string) => {
    setActiveModal(modalType);
  };
  const closeModal = () => {
    setActiveModal(null);
  };
  const termsContent = <div className="space-y-4 text-sm" data-id="element-135">
      <h3 className="font-bold text-lg" data-id="element-136">1. Terms of Use</h3>
      <p data-id="element-137">
        By accessing and using "Baby Food Made Simple," you agree to comply with
        these terms and conditions. If you disagree with any part of these
        terms, you should not use our product.
      </p>
      <h3 className="font-bold text-lg" data-id="element-138">2. Intellectual Property</h3>
      <p data-id="element-139">
        All content included in "Baby Food Made Simple," including text,
        graphics, logos, images, as well as their compilation, is the exclusive
        property of Dr. Patricia Morales and is protected by intellectual
        property laws.
      </p>
      <h3 className="font-bold text-lg" data-id="element-140">3. Usage Restrictions</h3>
      <p data-id="element-141">
        When purchasing "Baby Food Made Simple," you obtain a personal,
        non-transferable, and non-exclusive license to use the content. The
        following is not permitted:
      </p>
      <ul className="list-disc pl-5 space-y-1" data-id="element-142">
        <li data-id="element-143">
          Redistributing, selling, or sharing the content with third parties
        </li>
        <li data-id="element-144">Modifying or creating derivative works based on the material</li>
        <li data-id="element-145">Using the content for commercial purposes without authorization</li>
      </ul>
      <h3 className="font-bold text-lg" data-id="element-146">4. Disclaimer</h3>
      <p data-id="element-147">
        "Baby Food Made Simple" is provided "as is," without warranties of any
        kind. We do not guarantee that the content is applicable to all
        situations or that it will produce specific results.
      </p>
      <h3 className="font-bold text-lg" data-id="element-148">5. Limitation of Liability</h3>
      <p data-id="element-149">
        In no event shall the creators of "Baby Food Made Simple" be liable for
        direct, indirect, incidental, special, or consequential damages
        resulting from the use or inability to use our product.
      </p>
      <h3 className="font-bold text-lg" data-id="element-150">6. Modifications</h3>
      <p data-id="element-151">
        We reserve the right to modify these terms at any time. Modifications
        will take effect immediately after their publication.
      </p>
      <h3 className="font-bold text-lg" data-id="element-152">7. Applicable Law</h3>
      <p data-id="element-153">
        These terms shall be governed by and construed in accordance with
        applicable laws, without regard to their provisions on conflicts of
        laws.
      </p>
    </div>;
  const privacyContent = <div className="space-y-4 text-sm" data-id="element-154">
      <h3 className="font-bold text-lg" data-id="element-155">1. Information We Collect</h3>
      <p data-id="element-156">
        When purchasing "Baby Food Made Simple," we may collect the following
        information:
      </p>
      <ul className="list-disc pl-5 space-y-1" data-id="element-157">
        <li data-id="element-158">Contact information (name, email, etc.)</li>
        <li data-id="element-159">
          Payment information (processed securely by our payment providers)
        </li>
        <li data-id="element-160">Website usage and analytics data</li>
      </ul>
      <h3 className="font-bold text-lg" data-id="element-161">2. Use of Information</h3>
      <p data-id="element-162">We use the collected information to:</p>
      <ul className="list-disc pl-5 space-y-1" data-id="element-163">
        <li data-id="element-164">Process your purchase and provide access to the system</li>
        <li data-id="element-165">Communicate with you about your purchase</li>
        <li data-id="element-166">Improve our products and services</li>
        <li data-id="element-167">
          Send information about updates or related products (only with your
          consent)
        </li>
      </ul>
      <h3 className="font-bold text-lg" data-id="element-168">3. Data Protection</h3>
      <p data-id="element-169">
        We implement appropriate security measures to protect your personal
        information against unauthorized access, alteration, disclosure, or
        destruction.
      </p>
      <h3 className="font-bold text-lg" data-id="element-170">4. Sharing Information</h3>
      <p data-id="element-171">
        We do not sell, trade, or transfer your personal information to third
        parties, except to service providers who help us operate our business
        (payment processors, digital delivery services, etc.).
      </p>
      <h3 className="font-bold text-lg" data-id="element-172">5. Cookies and Similar Technologies</h3>
      <p data-id="element-173">
        We use cookies and similar technologies to improve the user experience,
        analyze traffic, and personalize content. You can configure your browser
        to reject cookies, although this may affect site functionality.
      </p>
      <h3 className="font-bold text-lg" data-id="element-174">6. Your Rights</h3>
      <p data-id="element-175">
        You have the right to access, correct, or delete your personal
        information. To exercise these rights, contact us through the provided
        means.
      </p>
      <h3 className="font-bold text-lg" data-id="element-176">7. Changes to This Policy</h3>
      <p data-id="element-177">
        We may update our privacy policy periodically. We will notify you of any
        significant changes through a notice on our website.
      </p>
    </div>;
  const contactContent = <div className="space-y-6 text-sm" data-id="element-178">
      <h3 className="font-bold text-lg" data-id="element-179">Contact</h3>
      <p data-id="element-180">
        For any questions, suggestions, or issues related to "Baby Food Made
        Simple," you can contact us through the following means:
      </p>
      <ul className="list-disc pl-5 space-y-1" data-id="element-181">
        <li data-id="element-182">Email: support@babyfoodmadesimple.com</li>
        <li data-id="element-183">Office hours: Monday to Friday, 9:00 AM - 6:00 PM (EST)</li>
      </ul>
      <div className="mt-6" data-id="element-184">
        <h4 className="font-medium mb-4" data-id="element-185">Contact Form</h4>
        <form className="space-y-4" data-id="element-186">
          <div data-id="element-187">
            <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-188">
              Name
            </label>
            <input type="text" id="name" className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm" data-id="element-189" />
          </div>
          <div data-id="element-190">
            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-191">
              Email
            </label>
            <input type="email" id="email" className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm" data-id="element-192" />
          </div>
          <div data-id="element-193">
            <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-194">
              Message
            </label>
            <textarea id="message" rows={4} className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm" data-id="element-195"></textarea>
          </div>
          <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition-colors" data-id="element-196">
            Send Message
          </button>
        </form>
      </div>
    </div>;
  return <footer className="bg-gray-100 py-12 mt-16" data-id="element-197">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-198">
        <div className="text-center mb-8" data-id="element-199">
          <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-200">
            BABY FOOD MADE SIMPLE
          </h2>
          <p className="text-sm text-gray-500" data-id="element-201">
            © 2025 Dr. Claire Morgan. All rights reserved.
          </p>
        </div>
        <div className="flex flex-wrap justify-center gap-4 mb-8" data-id="element-202">
          <button onClick={() => openModal('terms')} className="text-sm text-gray-600 hover:text-gray-900 underline" data-id="element-203">
            Terms and Conditions
          </button>
          <button onClick={() => openModal('privacy')} className="text-sm text-gray-600 hover:text-gray-900 underline" data-id="element-204">
            Privacy Policy
          </button>
          <button onClick={() => openModal('contact')} className="text-sm text-gray-600 hover:text-gray-900 underline" data-id="element-205">
            Contact
          </button>
        </div>
        <div className="text-center text-xs text-gray-500 mt-8" data-id="element-206">
          <p data-id="element-207">
            Results may vary. Always consult with your pediatrician before
            introducing new foods to your baby.
          </p>
        </div>
      </div>
      {/* Legal Modals */}
      <LegalModal isOpen={activeModal === 'terms'} onClose={closeModal} title="Terms and Conditions" content={termsContent} data-id="element-208" />
      <LegalModal isOpen={activeModal === 'privacy'} onClose={closeModal} title="Privacy Policy" content={privacyContent} data-id="element-209" />
      <LegalModal isOpen={activeModal === 'contact'} onClose={closeModal} title="Contact" content={contactContent} data-id="element-210" />
    </footer>;
}